import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, exhaustMap } from 'rxjs/operators';
import { ProductService } from '@/core/services/concreto-api-product.service';
import * as ProductActions from './product.actions';

@Injectable()
export class ProductEffects {
  // Usando inject() para obtener dependencias (patrón moderno)
  actions$ = inject(Actions);
  productService = inject(ProductService);

  constructor() {
    // Constructor vacío
  }
  
  // Efecto para buscar productos
  _searchProducts = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProductActions.searchProducts),
      exhaustMap((action) => {
        return this.productService.searchProducts(action.params).pipe(
          map((response) => {
            return ProductActions.loadProductsSuccess({
              products: response.data || [],
              pagination: response.pagination
            });
          }),
          catchError((error) => {
            console.error('API Error:', error);
            return of(ProductActions.loadProductsFailure({ error }));
          })
        );
      })
    );
  });

  // Efecto para cargar productos (si lo necesitas)
  _loadProducts = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProductActions.loadProducts),
      exhaustMap((action) => {
        return this.productService.getProducts(action.params || {}).pipe(
          map((response) => {
            return ProductActions.loadProductsSuccess({
              products: response.data || [],
              pagination: response.pagination
            });
          }),
          catchError((error) => {
            console.error('API Error:', error);
            return of(ProductActions.loadProductsFailure({ error }));
          })
        );
      })
    );
  });
}